import type { FilterConfig, FilterRow } from "./types";

export type FieldType = "text" | "select" | "resource-select";

export const findFilterConfig = (config: FilterConfig[], name?: string): FilterConfig | undefined => {
    if (!name) return undefined;
    for (const entry of config) {
        if (entry.name === name) return entry;
        const child = entry.children?.find((c) => c.name === name);
        if (child) return child;
    }
    return undefined;
};

export const getFieldMethod = (type?: FieldType): string => {
    switch (type) {
        case "select":
        case "resource-select":
            return "exact";
        case "text":
        default:
            return "contains";
    }
};

export const getDefaultFilterValue = (type?: FieldType): FilterRow["value"] => {
    switch (type) {
        case "resource-select":
            return [];
        case "select":
        case "text":
        default:
            return undefined;
    }
};
